/**

// Check if debug mode is enabled (global)
const urlParams = new URLSearchParams(window.location.search);

 * Search Progress Module - Управление прогресс баром поиска
 * 
 * Phase 5: UI Components Migration  
 * Migrated from main.js lines 1091-1115 (searchProgress function)
 */


/**
 * Search Progress Manager Class - handles search progress visualization
 */
class SearchProgressManager {
    constructor() {
        this.currentProgress = 0;
        this.progressSteps = {
            FILES: 33,
            PATH: 67, 
            CONTENT: 100
        };
        
        this.progressClasses = [
            'search-progress-badge-1',
            'search-progress-badge-2', 
            'search-progress-badge-3'
        ];
        
        // SearchProgressManager initialization logging only in debug mode
    }
    
    /**
     * Update search progress bar and badge
     * @param {number} share - Progress percentage (0-100)
     */
    updateProgress(share) {
        try {
            // Validate input
            if (typeof share !== 'number' || isNaN(share)) {
                if (debugMode === '1') {
                console.warn('[SearchProgressManager] Invalid share value, using 0:', share);
            }
                share = 0;
            }
            
            // Clamp to valid range
            share = Math.max(0, Math.min(100, share));
            
            this.currentProgress = share;
            
            if (window.HyperLog) {
                window.HyperLog.debug('[SearchProgressManager] Updating progress', {
                    share: share,
                    step: this.getProgressStep(share)
                });
            }
            
            // Update progress bar animation
            this.updateProgressBar(share);
            
            // Update progress badge
            this.updateProgressBadge(share);
            
            // Update search button state
            this.updateSearchButton(share);
            
        } catch (error) {
            if (debugMode === '1') {
                console.error('[SearchProgressManager] Error updating progress:', error);
            }
        }
    }
    
    /**
     * Update the animated progress bar
     * @param {number} share - Progress percentage
     */
    updateProgressBar(share) {
        const left = share;
        const width = 100 - share;
        
        const progressBar = $('.search-bg');
        if (progressBar.length > 0) {
            progressBar.animate({
                'left': `${left}%`,
                'width': `${width}%`
            }, 100, 'swing');
        }
    }
    
    /**
     * Update progress badge text and styling
     * @param {number} share - Progress percentage
     */
    updateProgressBadge(share) {
        const badge = $('.search-progress-badge');
        if (badge.length === 0) return;
        
        const step = this.getProgressStep(share);
        const stepName = this.getStepName(step);
        
        // Update badge text
        const searchModeText = this.translate(`search_mode_${stepName}`);
        badge.text(searchModeText);
        
        // Update badge classes
        const currentClass = `search-progress-badge-${step}`;
        const classesToRemove = this.progressClasses.filter(cls => cls !== currentClass);
        
        badge.removeClass(classesToRemove.join(' '));
        if (!badge.hasClass(currentClass)) {
            badge.addClass(currentClass);
        }
        
        // Update tooltip
        const descText = this.translate(`search_mode_${stepName}_desc`);
        badge.prop('title', descText);
    }
    
    /**
     * Update search button state based on progress
     * @param {number} share - Progress percentage
     */
    updateSearchButton(share) {
        const button = $('.search-button-full-text-search');
        if (button.length === 0) return;
        
        if (share === 100) {
            button.addClass('text-canvas bg-rons-grad search-progress-button');
        } else {
            button.removeClass('text-canvas bg-rons-grad search-progress-button');
        }
    }
    
    /**
     * Get progress step number based on percentage
     * @param {number} share - Progress percentage
     * @returns {number} Step number (1, 2, or 3)
     */
    getProgressStep(share) {
        return Math.round(share / 33) || 1;
    }
    
    /**
     * Get step name based on step number
     * @param {number} step - Step number
     * @returns {string} Step name
     */
    getStepName(step) {
        switch (step) {
            case 1: return 'files';
            case 2: return 'path'; 
            case 3: return 'content';
            default: return 'files';
        }
    }
    
    /**
     * Translation helper function
     * @param {string} key - Translation key
     * @returns {string} Translated text
     */
    translate(key) {
        // Use global translate function if available, otherwise return key
        if (window.translate && typeof window.translate === 'function') {
            return window.translate(key);
        }
        return key;
    }
    
    /**
     * Get current progress percentage
     * @returns {number} Current progress
     */
    getCurrentProgress() {
        return this.currentProgress;
    }
    
    /**
     * Set progress to files step (33%)
     */
    setFilesProgress() {
        this.updateProgress(this.progressSteps.FILES);
    }
    
    /**
     * Set progress to path step (67%)
     */
    setPathProgress() {
        this.updateProgress(this.progressSteps.PATH);
    }
    
    /**
     * Set progress to content/complete step (100%)
     */
    setContentProgress() {
        this.updateProgress(this.progressSteps.CONTENT);
    }
    
    /**
     * Reset progress to initial state
     */
    resetProgress() {
        this.updateProgress(0);
    }
    
    /**
     * Check if progress is at a specific step
     * @param {string} stepName - Step name ('files\', 'path', \'content')
     * @returns {boolean} True if at specified step
     */
    isAtStep(stepName) {
        const stepValue = this.progressSteps[stepName.toUpperCase()];
        return stepValue && this.currentProgress === stepValue;
    }
    
    /**
     * Get progress statistics
     * @returns {Object} Progress statistics
     */
    getStats() {
        return {
            currentProgress: this.currentProgress,
            currentStep: this.getProgressStep(this.currentProgress),
            currentStepName: this.getStepName(this.getProgressStep(this.currentProgress)),
            isComplete: this.currentProgress === 100
        };
    }
}

// Create singleton instance
const searchProgressManager = new SearchProgressManager();

// Export for use in other modules
export { searchProgressManager };

// Global export for backward compatibility
window.searchProgressManager = searchProgressManager;

// Legacy function compatibility
window.searchProgress = (share) => {
    searchProgressManager.updateProgress(share);
};

// Register with migration controller
//         'updateProgress',
//         'setFilesProgress',
//         'setPathProgress', 
//         'setContentProgress',
//         'resetProgress',
//         'getCurrentProgress',
//         'isAtStep',
//         'getStats'
    
//     // Mark as migrated from main.js
// }

// Module loaded logging only in debug mode 